import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardRepostInternshipRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardRepostInternshipPageContainerLoadable } from './OrgDashboardRepostInternshipPageContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardRepostInternshipRoute>,
) {
  await OrgDashboardRepostInternshipPageContainerLoadable.load();
}

export default function OrgDashboardRepostInternshipHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardRepostInternshipPageContainerLoadable />;
}
